import { OrderProductRootGroup } from 'src/adminPanel/components/order/dialog/OrderProductsDialog';
import { action } from 'src/store/actions';

export const FETCH_PRODUCT_GROUPS = 'FETCH_PRODUCT_GROUPS';
export const REQUEST_PRODUCT_GROUPS = 'REQUEST_PRODUCT_GROUPS';
export const SUCCESS_PRODUCT_GROUPS = 'SUCCESS_PRODUCT_GROUPS';
export const FAILURE_PRODUCT_GROUPS = 'FAILURE_PRODUCT_GROUPS';

export const fetchProductGroups = (rootGroup: OrderProductRootGroup) => action(FETCH_PRODUCT_GROUPS, { rootGroup });
export const requestProductGroups = () => action(REQUEST_PRODUCT_GROUPS);
export const requestProductGroupsSuccess = (response: any) => action(SUCCESS_PRODUCT_GROUPS, { response });
export const requestProductGroupsFailure = (error: any) => action(FAILURE_PRODUCT_GROUPS, { error });
